exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected{\n    background: #33a853;\n    border: 0px;\n    color: #fff;\n}\n\n.notSelected{\n    background: red;\n    border: 0px;\n    color: #fff;\n}\n\n.review{\n    background: #816cb5;\n    border: 0px;\n    color: #fff;\n}\n\n.selectreview{\n    background:#816cb5;\n    border: 0px;\n    color: #fff;\n}\n\n.aa button {\n    -webkit-box-shadow: 0 2px 2px 0 rgba(177, 177, 177, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(99, 99, 99, 0.12);\n    box-shadow: 0 2px 2px 0 rgba(177, 177, 177, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(99, 99, 99, 0.12);\n    font-size: 12px;\n    letter-spacing: .4px;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    position: relative;\n}\n\n.instruction-MQ-box {\n    margin: 0 auto;\n    text-align: center;\n   \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/online-mcq/common-instruction/common-instruction.component.css
// module id = ../../../../../src/app/online-mcq/common-instruction/common-instruction.component.css
// module chunks = common